import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { useAuth } from '../../../hooks/auth';
import {
  AttentionIcon,
  FuzzyLogoNewOrange,
} from '../../../assets/svg/SVGComponents';

import { Container, Content, ErrorMessage } from '../styles';

const NotFound: React.FC = () => {
  const { t } = useTranslation();
  const { isAuthenticated } = useAuth();

  return (
    <Container>
      <Content>
        <FuzzyLogoNewOrange />
        <ErrorMessage>
          <span className="error-icon">
            <AttentionIcon
              width="5rem"
              strokeWidth="1.5"
              fill="none"
              stroke="#ff9800"
            />
          </span>
          <h2>
            {t('errors.not_found_title', {
              defaultValue: 'Página não encontrada',
            })}
          </h2>
          <p>
            {t('errors.not_found_description', {
              defaultValue: 'O endereço acessado não existe ou foi movido.',
            })}
          </p>

          <div className="actions">
            <Link to={isAuthenticated ? '/home' : '/'}>
              {t('errors.back_home', { defaultValue: 'Voltar ao início' })}
            </Link>
          </div>
        </ErrorMessage>
      </Content>
    </Container>
  );
};

export default NotFound;
